import moment from "moment";
import { useRecoilState } from "recoil";
import participantsState from "../../atoms/participants";
import userDetailsState from "../../atoms/userDetails";
import { UserDetail } from "../../connector/type";
import Member from "./Member";
import "./Members.scoped.scss"

// UserDetail, roomOwnerId => Admin: 3, Member: 1, Guest: 0
const getUserOrder = (d: UserDetail | undefined) => d == null 
  ? 0 
  : (
    d.level >= 28 
      ? 3 
      : (1 + (0.01 * d.level))
    );

function Members() {
  const [participants] = useRecoilState(participantsState);
  const [userDetails] = useRecoilState(userDetailsState);

  const thumbnailUrlTailer = Math.floor(moment().unix() / 60);
  
  // Remove duplicates
  const users = participants.users.filter((v, i, a) => a.indexOf(v) === i);
  // Sort (Order by desc)
  users.sort((a, b) => getUserOrder(userDetails.get(b)) - getUserOrder(userDetails.get(a)));
  // Build component
  const members = users.map((userId, index) => {
    const userDetail = userDetails.get(userId);
    const level = userDetail?.level ?? 1;
    const nickname = (userDetail?.nickname && userDetail?.nickname !== '') ? userDetail.nickname : userId;
    const thumbnailUrl = userDetail?.hasThumbnail
      ? `/data/member_image/${userId.substring(0, 2)}/${userId}.gif?${thumbnailUrlTailer}`
      : '/img/profile.png';
    return (
      <Member 
        key={index} 
        level={level} 
        nickname={nickname} 
        thumbnailUrl={thumbnailUrl}
        todayComment={userDetail?.todayComment}
      />
    )
  });

  return (
    <div className="members">
      <div className="members__header">
        대기실 <b>{users.length}</b>명
      </div>
      <div className="members__contents" style={{height: 'calc(100vh - 443px)'}}>
        {members}
      </div>
    </div>
  );
}

export default Members;
